import { render, staticRenderFns } from "./ReserveOptionStocks.vue?vue&type=template&id=0dd8c724&scoped=true"
import script from "./ReserveOptionStocks.vue?vue&type=script&lang=js"
export * from "./ReserveOptionStocks.vue?vue&type=script&lang=js"
import style0 from "./ReserveOptionStocks.vue?vue&type=style&index=0&id=0dd8c724&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd8c724",
  null
  
)

export default component.exports